import React, { useState, useEffect, useContext } from "react";
import languageContext from "../context/language/languageContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

const NursePatientDashboard = () => {
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const { setSessionTimeout, setAlert, setMessage } = useContext(languageContext);

  const navigate = useNavigate();

  const getPatientDetails = async () => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/nurse_patient_details_interaction",
        {},
        { headers: headersList }
      );
      if (response.status === 200) {
        setPatients(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getPatientDetailsSearch = async (value) => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/nurse_patient_details_interaction",
        { search: value },
        { headers: headersList }
      );
      if (response.status === 200) {
        setPatients(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleError = (error) => {
    setLoading(false);
    if (error.response?.data?.detail === "Token has expired") {
      setSessionTimeout(true);
    } else {
      console.error("Error Details:", error.message);
      setAlert(true);
      setMessage("Please try again later, something went wrong");
    }
  };

  useEffect(() => {
    const init = async () => {
      const currentPagePath = window.location.pathname;
      const loginBool = localStorage.getItem("login");

      if (loginBool === "true") {
        navigate("/patient-details", { state: { url: currentPagePath } });
        await getPatientDetails();
      } else {
        navigate("/login", { state: { url: currentPagePath } });
      }
    };

    init();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getPatientDetailsSearch(searchTerm.trim());
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleView = (path, patient_id) =>
    navigate(path, { state: { patient_id } });

  return (
    <div className="min-h-screen bg-white to-emerald-100">
    {/* // <div className="min-h-screen bg-gradient-to-r from-green-50 to-emerald-100"> */}
      {/* Fixed Navbar */}
      <Navbar />

      <div className="container mx-auto px-4 pt-28 pb-12">
        <h1 className="text-3xl font-bold text-emerald-800 mb-6 text-center">
          Nurse Dashboard – Patient Details
        </h1>

        {/* Search Bar */}
        <div className="flex justify-center mb-8">
          <input
            type="text"
            placeholder="Search by name, phone, or ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full max-w-md px-4 py-2 rounded-lg border border-emerald-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-400"
          />
        </div>

        {/* Patients Container */}
        <div className="flex flex-col w-full lg:w-10/12 xl:w-8/12 mx-auto p-4 bg-white/90 shadow-xl rounded-2xl h-[80vh] overflow-y-auto scrollbar-thin scrollbar-thumb-emerald-400">
          {loading ? (
            <div className="flex justify-center items-center h-full">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-emerald-600"></div>
            </div>
          ) : patients.length === 0 ? (
            <p className="text-center text-gray-600">No patients found.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {patients.map((patient) => (
                <div
                  key={patient.id}
                  className="bg-white rounded-xl shadow hover:shadow-lg border border-emerald-200 p-4 transition"
                >
                  <h2 className="text-lg font-semibold text-emerald-700">
                    {patient.name}
                  </h2>
                  <p className="text-gray-600 text-xs mt-1">Phone: {patient.phone}</p>
                  <p className="text-gray-600 text-xs">Age: {patient.age}</p>
                  <p className="text-gray-600 text-xs">Gender: {patient.gender}</p>

                  <div className="mt-4 flex flex-col space-y-2">
                    <button
                      onClick={() => handleView("/chat_history", patient.id)}
                      className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-1.5 rounded text-xs"
                    >
                      View Chat History
                    </button>
                    <button
                      onClick={() => handleView("/view_appointment", patient.id)}
                      className="w-full bg-green-600 hover:bg-green-700 text-white py-1.5 rounded text-xs"
                    >
                      View Appointments
                    </button>
                    <button
                      onClick={() => handleView("/view_lab_test", patient.id)}
                      className="w-full bg-blue-600 hover:bg-blue-700 text-white py-1.5 rounded text-xs"
                    >
                      View Lab Tests
                    </button>
                    <button
                      onClick={() => handleView("/view_reminder", patient.id)}
                      className="w-full bg-purple-600 hover:bg-purple-700 text-white py-1.5 rounded text-xs"
                    >
                      View Reminders
                    </button>
                    <button
                      onClick={() => handleView("/chat_summary", patient.id)}
                      className="w-full bg-orange-500 hover:bg-orange-600 text-white py-1.5 rounded text-xs"
                    >
                      View Patient Summary
                    </button>
                    <button onClick={() => handleView("/prescription_history", patient.id)} className="w-full bg-yellow-600 hover:bg-yellow-700 text-white py-1 rounded text-xs">📄 View Prescription History</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NursePatientDashboard;
